module.exports = __webpack_public_path__ + "img/three_high_user_qrcode.05226de5.png";